var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row-title-btn"},[_c('v-card-title',{directives:[{name:"show",rawName:"v-show",value:(!_vm.searchActive),expression:"!searchActive"}]},[_vm._v("Página de Administracion y saneamiento de inmuebles")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }